import { forwardRef } from 'react';
import * as RadioGroupPrimitive from '@radix-ui/react-radio-group';
import classNames from 'classnames';

import { RadioGroupItem } from './RadioGroupItem';

import styles from './RadioGroup.module.scss';

export type RadioGroupOptions = {
    value: string;
    label: React.ReactNode;
}[];

export interface IRadioGroupProps extends RadioGroupPrimitive.RadioGroupProps {
    children: React.ReactNode;
}

const RadioGroupRoot = forwardRef<HTMLDivElement, IRadioGroupProps>(({ className, children, ...props }, ref) => {
    return (
        <RadioGroupPrimitive.Root ref={ref} className={classNames(styles.root, className)} {...props}>
            {children}
        </RadioGroupPrimitive.Root>
    );
});

export const RadioGroup = { Root: RadioGroupRoot, Item: RadioGroupItem };
